import { scrollToHash } from "./SmoothScroll";

const MENU = [
  { label: "Come funziona", href: "#come-funziona" },
  { label: "Il servizio", href: "#servizio" },
  { label: "Il professionista", href: "#professionista" },
  { label: "Per chi è", href: "#per-chi" },
  { label: "FAQ", href: "#faq" },
  { label: "Contatti", href: "#contatti" },
];

const LEGAL = ["Privacy Policy", "Cookie Policy", "Termini e condizioni"];

export default function Footer() {
  const go = (e, href) => {
    e.preventDefault();
    scrollToHash(href);
  };

  return (
    <footer data-testid="footer-section" className="relative overflow-hidden border-t border-white/10 bg-[#080D1F]">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8 lg:pt-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div className="flex flex-col gap-5">
            <div className="flex items-center self-start rounded-xl bg-white px-3 py-2">
              <img src="/hf-logo-extended.webp" alt="Human Factor" className="h-9 w-auto" />
            </div>
            <p className="font-display text-lg font-bold text-white">Il lato umano della tua Partita IVA.</p>
            <p className="max-w-sm text-sm leading-relaxed text-slate-400">
              Un unico spazio digitale per gestire la tua Partita IVA forfettaria, con professionisti interni sempre al
              tuo fianco.
            </p>
          </div>

          <nav className="flex flex-col gap-3">
            <p className="font-display text-sm font-bold uppercase tracking-wider text-white">Menu</p>
            {MENU.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`footer-link-${l.href.slice(1)}`}
                onClick={(e) => go(e, l.href)}
                className="w-fit text-sm text-slate-400 transition-colors hover:text-cyan-300"
              >
                {l.label}
              </a>
            ))}
            <a href="https://app.hfweb.it" data-testid="footer-link-accedi" className="w-fit text-sm text-slate-400 transition-colors hover:text-cyan-300">
              Accedi
            </a>
          </nav>

          <div className="flex flex-col gap-3">
            <p className="font-display text-sm font-bold uppercase tracking-wider text-white">Legal</p>
            {LEGAL.map((l) => (
              <span key={l} data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z]/g, "-")}`} className="w-fit text-sm text-slate-400">
                {l}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6">
          <p className="text-xs text-slate-500">© Human Factor – Tutti i diritti riservati.</p>
        </div>
      </div>

      <div className="pointer-events-none select-none whitespace-nowrap text-center font-display text-[14vw] font-extrabold leading-[0.8] text-white/[0.03] lg:text-[11vw]">
        Human Factor
      </div>
    </footer>
  );
}
